import { Component } from '@angular/core';
import { TermsComponent } from '@b2b/components/terms/terms.component';

@Component({
  selector: 'cx-terms-section',
  imports: [TermsComponent],
  templateUrl: './cx-terms-section.component.html',
})
export class CxTermsSectionComponent {}
